import { render, staticRenderFns } from "./reservation-form.vue?vue&type=template&id=0286cdbc&scoped=true&"
import script from "./reservation-form.ts?vue&type=script&lang=ts&"
export * from "./reservation-form.ts?vue&type=script&lang=ts&"
import style0 from "./reservation-form.scss?vue&type=style&index=0&id=0286cdbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0286cdbc",
  null
  
)

export default component.exports